import styled from 'styled-components';

const ButtonStyle = styled.div`
	&.btn {
		width: fit-content;
		cursor: pointer;

		a,
		button {
			display: flex;
			align-items: center;
			justify-content: center;
			text-align: center;
			color: var(--black1000);
			font-size: var(--p4);
			font-family: var(--neue);
			font-weight: 400;
			line-height: var(--lineHeightL);
			background-color: transparent;
			text-transform: uppercase;
			isolation: isolate;
			backface-visibility: visible;
			overflow: hidden;
			position: relative;
			cursor: pointer;

			.outside-wrapper-button {
				position: relative;
				overflow: hidden;

				&::before {
					content: '';
					position: absolute;
					bottom: 0;
					left: 0px;
					height: 2px;
					width: 100%;
					background-color: var(--black1000);
				}

				.text-button,
				.text-button-hover {
					display: flex;
					align-items: center;
					width: 100%;
					height: 100%;
					transition: var(--trTime) ease-out;
					will-change: transform;
				}

				.text-button-hover {
					position: absolute;
					bottom: -100%;
					left: 0;
				}
			}

			@media (pointer: fine) {
				@media (hover: hover) {
					&:hover {
						.outside-wrapper-button {
							.text-button-hover {
								bottom: 0;
							}

							.text-button {
								transform: translateY(-100%);
							}
						}
					}
				}
			}
		}
	}

	&.disabled {
		pointer-events: none;

		a,
		button {
			opacity: 0.5;
			pointer-events: none;
		}
	}

	//! 1920
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeXLMin}) {
	}

	//! 1536
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeLMin}) {
	}

	//! 1366
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeMMin}) {
	}

	//! 1280
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeSMin}) {
	}

	//! 1024
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.tabletSizeMin}) {
	}

	//! 768
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.tabletSizeXMin}) {
	}

	//! Mobile
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.tabletSizeSMin}) {
	}
`;

export default ButtonStyle;
